import { z } from 'zod';
/** Route params for the staff endpoint that deletes a previsit form. */
export const PrevisitFormRemoveParamsSchema = z.object({ formId: z.uuid() }).strict();
/** Route params for the patient app endpoints addressing a single previsit form. */
export const PrevisitFormIdParamsSchema = z.object({ previsitFormId: z.uuid() }).strict();
/**
 * `score` is the single total the patient app has always sent; `scores` is the per-primitive map
 * that replaces it. Both are written while the two representations coexist, so neither is required.
 *
 * A total may be negative. Option scores are authored per answer and the template contract accepts
 * a negative one, so a reverse-scored question sums below zero; refusing the total here only threw
 * the patient's score away.
 */
export const PrevisitFormScoreUpdateSchema = z
    .object({
    score: z.number().default(0),
    scores: z.record(z.string(), z.number()).optional(),
})
    .strict();
//# sourceMappingURL=form.js.map